// extracted by mini-css-extract-plugin
export var container = "_dn-0";
export var icon = "_dn-1";
export var text = "_dn-2";